/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import LineGraph from '../../graphs/base/LineGraph.js';
import AssignStudents from '../../wizard/create-class-steps/review-students.js';
import {ControlLabel , Row , Col , FormGroup , FormControl} from 'react-bootstrap';
import DataInput from '../../inputs/date.input.js'
import VocabSelect from '../../wizard/assignment-steps/select-content.js';
class AboutPanel extends React.Component {

    constructor(props){
        super();
        this.props = {};
        this.state ={
            wordsLearnt:[]
        }

        var d =   new Date();
        var due = new Date();
        due.setDate(due.getDate() + 14);

        this.props.set = d.toISOString();
        this.props.due = due.toISOString();
    }

    componentDidMount(){

    }

    componentWillMount(){

    }

    handelClassNameChange(){

    }

    handelSetDataSelect(){

    }

    handelDueDataSelect(){

    }

    render(){

        const content = VocabSelect.component;
        return (
            <div>
                <div className="pmb-block m-5">
                    <Row>
                        <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'Header.greeting' } defaultMessage={ 'Name' }/><small></small></ControlLabel>
                                <FormControl type="text" onChange={this.handelClassNameChange}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup className="fg-line">
                                <ControlLabel  className="fg-label"><FormattedMessage id={ 'Header.greeting' } defaultMessage={ 'Name' }/><small></small></ControlLabel>
                                <FormControl type="text" onChange={this.handelClassNameChange}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}><DataInput onSelect={this.handelSetDataSelect} value={this.props.set} labelTranslationUID="99999" labelName="Set"/></Col>
                        <Col sm={6}><DataInput onSelect={this.handelDueDataSelect} value={this.props.due}labelTranslationUID="9999" labelName="Due"/></Col>
                    </Row>
                    <Row>
                        <content data={{}} />
                    </Row>
                </div>
            </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-784' } defaultMessage={ 'Assignments' }/>,
    component: AboutPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/homework-class-panel.js